import { render, staticRenderFns } from "./InventoryAdvancePaymentApproverPicker.vue?vue&type=template&id=39735f4c&"
import script from "./InventoryAdvancePaymentApproverPicker.vue?vue&type=script&lang=ts&"
export * from "./InventoryAdvancePaymentApproverPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports